import React from "react";
import './About/About.css';


const SectionHeading = ({number, heading}) => {
    return (
        <div>
            <h2 className="about-heading">
                <span>{number} </span> 
                {heading}
                <hr style={{width: '150px', background: '#a8b2d1', marginLeft:'20px' }}></hr>
            </h2>
            

        </div>

    )
}

export default SectionHeading;